import axios from 'axios';

/**
 * Форма жалобы, отзыва
 * @returns {Promise<void>}
 * @constructor
 */
export default async function ReviewComplainModal() {

  /**
   * Навешивание событий на элементы выпадающего списка
   * @param selectsItems
   */
  function setDropdownItemsEvent(selectsItems) {
    selectsItems.forEach((selectItem) => {
      selectItem.addEventListener('click', function () {
        const openDropdown = document.querySelector('.dropdown-open');
        if (openDropdown) {
          openDropdown.classList.remove('dropdown-open');
          openDropdown.querySelector('.dropdown-body').style.height = '';
        }
        const headElem = this.closest('.dropdown-item').querySelector('.dropdown-head .head-text');
        headElem.innerHTML = this.innerHTML;
        if (this.dataset.doctid) {
          headElem.dataset.doctid = this.dataset.doctid;
        }
        if (this.dataset.convtime) {
          headElem.dataset.convtime = this.dataset.convtime;
        }
      });
    });
  }

  const citiesSelect = document.querySelectorAll(' .form-item.city-picker .dropdown-item .dropdown-body .body-item');
  if (citiesSelect) {
    citiesSelect.forEach((citySelect) => {
      // Обработка смены города
      citySelect.addEventListener('click', async function onCityChanged() {
        const tabsForms = document.querySelectorAll('#appointment-form-template');
        let activeTabDataset = false;
        tabsForms.forEach((tabsForm) => {
          const thisDropdownHead = tabsForm.querySelector('.clinic-select .dropdown-head');
          activeTabDataset = tabsForm.querySelector('.tab-active').dataset.tab;
          thisDropdownHead.querySelector('.head-text').dataset.cityid = citySelect.dataset.cityid;
          thisDropdownHead.querySelector('.head-text').innerHTML = citySelect.innerHTML;
        });
        // Получение и вывод докторов
        const { data } = await axios.get('/api/get-appointment-doctors', {
          params: {
            cityId: this.dataset.cityid,
            isChild: activeTabDataset !== 'adult_form',
          },
        });
        if (data.status) {
          let doctorsSelectItems = '';
          Object.entries(data.data).forEach(([value, key]) => {
            doctorsSelectItems += `  <div data-doctid="${key}" class="body-item">
                                            ${value}
                                        </div>`;
          });
          const thisForm = this.closest('form');
          const thisDropdownHead = thisForm.querySelector('.doctors-select .dropdown-head');
          const selectHead = thisDropdownHead.querySelector('.head-text');
          selectHead.innerText = 'Любой врач';
          selectHead.dataset.doctid = -1;
          const doctorsSelectBody = thisForm.querySelector('.doctors-select .dropdown-body');
          doctorsSelectBody.innerHTML = doctorsSelectItems;
          setDropdownItemsEvent(doctorsSelectBody.querySelectorAll('.body-item'));
        }
      });
    });
  }

  const modalFormInputs = document.querySelectorAll('.file-input input[name="file"]');
  modalFormInputs.forEach((inputElement) => {
    const fileInputCont = inputElement.closest('.file-input');
    inputElement.addEventListener('change', () => {
      if (inputElement.files.length) {
        updateThumbnail(fileInputCont, inputElement.files[0]);
      }
    });
  });

  /**
   * @param {HTMLElement} fileInputCont
   * @param {File} file
   */
  function updateThumbnail(fileInputCont, file) {
    const KByte = 1024;
    const MByte = 1024 * KByte;

    const formContainer = fileInputCont.closest('form');
    if (file.size > 5 * MByte) {
      formContainer.querySelector('.file-input-desc').classList.add('file-err');
      return;
    }
    formContainer.querySelector('.file-input-desc').classList.remove('file-err');
    fileInputCont.classList.add('is-upload');
    const fileDesc = fileInputCont.querySelector('.upload-file-desc .file-desc');
    const removeBtn = fileInputCont.querySelector('#remove-file');

    fileDesc.innerText = file.name;

    // remove upload file
    removeBtn.addEventListener('click', () => {
      const fileInput = fileInputCont.querySelector('[name="file"]');
      fileInput.value = '';

      // Очистка уже загруженного файла для нового
      if (fileInputCont.classList.contains('is-upload')) {
        fileInputCont.classList.remove('is-upload');
        fileDesc.innerText = 'Файл не выбран...';
      }
    });
  }

  // Валидация формы
  const isRequired = (value) => value !== '';

  const checkName = (activeForm) => {
    const nameInput = activeForm.querySelector('#fio');
    const formItem = nameInput.closest('.form-item');
    if (!isRequired(nameInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkReview = (activeForm) => {
    const commentInput = activeForm.querySelector('#comment');
    const formItem = commentInput.closest('.form-item');
    if (!isRequired(commentInput.value.trim())) {
      formItem.classList.add('err-item');
      return false;
    }
    formItem.classList.remove('err-item');
    return true;
  };

  const checkEmailValid = (activeForm) => {
    const emailItem = activeForm.querySelector('#email');
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidRes = re.test(emailItem.value.trim().replace(/\s/g, ''));
    if (!isValidRes) {
      emailItem.closest('.form-item').classList.add('err-item');
      return false;
    }
    emailItem.closest('.form-item').classList.remove('err-item');

    return true;
  };

  const checkPersonal = (activeForm) => {
    const personalCheck = activeForm.querySelector('[name="agreedBox"]');
    if (!personalCheck.checked) {
      personalCheck.closest('.form-checkbox').classList.add('err-box');
      return false;
    }
    personalCheck.closest('.form-checkbox').classList.remove('err-box');

    return true;
  };

  // Проверка валидности формы
  function isValid(activeForm) {
    const formName = checkName(activeForm);
    const formComment = checkReview(activeForm);
    const email = checkEmailValid(activeForm);
    const personalValid = checkPersonal(activeForm);

    return formName && email && personalValid && formComment;
  }

  // Нажатие на кнопке отправить
  const formSendBtns = document.querySelectorAll('.complain-review-modal .form-send');
  if (formSendBtns) {
    // eslint-disable-next-line no-restricted-syntax
    for (const btn of formSendBtns) {
      const activeForm = btn.closest('.complain-review-modal');
      await sendAppointment(btn, activeForm);
    }
  }

  /**
   * Отправка данных с формы Жалобы или Отзыва.
   * @returns {Promise<void>}
   */
  async function sendAppointment(button, form) {
    /**
     * Отправка формы записи на приём
     * @param {Event} event
     */
    async function sendFn(event) {
      event.preventDefault();
      const token = document.querySelector('meta[name="csrf-token"]').content;
      const selectedForm = form.querySelector('input[name="formType"]').value;
      const file = form.querySelector('[name="file"]').files[0];

      const formData = new FormData();
      formData.append('page_url', window.location.href);
      formData.append('page_name', document.querySelector('title').innerText.trim());
      formData.append('appoint_privacy', form.querySelector('[name="agreedBox"]').checked ? 1 : 0);
      formData.append('user_full_name', form.querySelector('#fio').value.trim());
      formData.append('doctor_id', form.querySelector('.doctors-select .dropdown-head .head-text').dataset.doctid);
      formData.append('city_id', form.querySelector('.city-picker .dropdown-head .head-text').dataset.cityid.trim());
      formData.append('comment', form.querySelector('[name="comment"]').value.trim());
      formData.append('email', form.querySelector('#email').value.trim());
      formData.append('selected_form', selectedForm);
      formData.append('form_file', file !== undefined ? file : '');

      if (isValid(form)) {
        try {
          button.disabled = true;
          button.innerText = 'Отправление';
          //
          const q = await axios.post('/reviews_add/', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-CSRF-TOKEN': token,
            },
          });
          const { status, html } = q.data;

          if (status) {
            const formContainer = form.querySelector('.form-container');
            formContainer.innerHTML = html;

            // отправляем событие в GTM
            if (form.classList.contains('review-modal') && window.dataLayer) {
              window.dataLayer.push({
                event: 'GoalEvent',
                eventCategoryUA: 'review',
                eventActionUA: 'sendForm',
                eventGoalYM: 'review_sendForm',
                eventGA4: 'review_sendForm',
              });
            }

            // отправляем событие в GTM
            if (form.classList.contains('complain-modal') && window.dataLayer) {
              window.dataLayer.push({
                event: 'GoalEvent',
                eventCategoryUA: 'complain',
                eventActionUA: 'sendForm',
                eventGoalYM: 'complain_sendForm',
                eventGA4: 'complain_sendForm',
              });
            }
          }
        } catch (err) {
          console.log('Catch error', err);
          button.disabled = false;
          button.innerText = 'Ошибка. Попробуйте еще раз';
        }
      }
    }

    button.addEventListener('click', sendFn);
  }

  // Функция небольшой задержки.
  // Срабатывает, когда происходит ввод данных в форме
  const debounce = (fn, delay = 100) => {
    let timeoutId;
    return (...args) => {
      // cancel the previous timer
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // setup a new timer
      timeoutId = setTimeout(() => {
        fn.apply(null, args);
      }, delay);
    };
  };

  const tabsForms = document.querySelectorAll('.modal-form input, .modal-form textarea');
  tabsForms.forEach((tabsForm) => {
    // Проверка на правильность заполнения полей при потере фокуса
    tabsForm.addEventListener('blur', debounce((e) => {
      const actForm = e.target.closest('.modal-form');
      switch (e.target.id) {
        case 'fio':
          checkName(actForm);
          break;
        case 'comment':
          checkReview(actForm);
          break;
        case 'email':
          checkEmailValid(actForm);
          break;
        default:
          break;
      }
    }));

    // Снятие выделения полей при вводе
    tabsForm.addEventListener('focus', debounce(() => {
      const parentItem = tabsForm.closest('.form-item');
      parentItem.classList.remove('err-item');
    }));
  });
}
